@if (type == 'school') {
  @if (loading) {
    <loader></loader>
  }
  @if (!loading && list.length) {
    <block>
      <block-title><h1>{{ title | translate | uppercase }}</h1></block-title>
      <block-content>
        <listItems [list]="list" type="studyProgramme" compare="studyProgrammeComparison"></listItems>
        @if (!loading && !list.length) {
          <div class="text-center">
            {{ 'studyProgramme.no_results' | translate }}
          </div>
          }<!--/text-center-->
        </block-content>
      </block>
    }
    <div class="loadMore-wrapper" [class.load-more--space-bottom]="!loadingMore && (totalItems+1 > ((1 + page)  * 24))">
      @if (loadingMore) {
        <loader></loader>
      }
      @if (!loadingMore && (totalItems+1 > ((1 + page)  * 24))) {
        <button
          htm-button
          (click)="loadMore()"
          type="button"
          data-test-id="related-study-programmes-school-load-more-button"
        >{{ 'button.load_more' | translate }}</button>
      }
    </div><!--/loadMore-->
  } @else {
    @if (!loading && list.length && !showList) {
      <div class="text-center">
        <button
          htm-button
          data-test-id="related-study-programmes-view-similar-button"
        (click)="showListItems()">{{ 'studyProgramme.view_similar' | translate }}</button>
      </div>
      }<!--/text-center-->
      @if (showList) {
        <block>
          <block-title><h2>{{ title | translate | uppercase }}</h2></block-title>
          <block-content>
            <form [formGroup]="relatedProgrammesForm" class="filter-wrapper" (submit)="getRelatedStudyprogrammes(nid)" filters>
              <formItem
                title="{{ 'studyProgramme.related_filter_location' | translate }}"
                type="text"
                name="address"
                formControlName="address"
                testId="related-study-programmes-search-address-field"
              ></formItem>
              <button
                type="button"
                (click)="getRelatedStudyprogrammes(nid)"
                htm-button
                data-test-id="related-study-programmes-search-submit-button"
              >{{ 'button.search' | translate}}</button>
            </form>
            @if (loading) {
              <loader></loader>
            }
            @if (!loading && !list.length) {
              <div class="text-center">
                {{ 'studyProgramme.related_no_results' | translate }}
              </div>
              }<!--/text-center-->
              @if (searchWithParams && !loading && totalItems && list?.length) {
                <label-count [count]="totalItems">{{ 'search.results_of' | translate }}: </label-count>
              }
              @if (!loading) {
                <listItems [list]="list" type="studyProgramme" compare="studyProgrammeComparison"></listItems>
              }
            </block-content>
          </block>
        }
        @if (showList && !loading) {
          <div class="loadMore-wrapper" [class.load-more--space-bottom]="!loadingMore && (totalItems+1 > ((1 + page)  * 24))">
            @if (loadingMore) {
              <loader></loader>
            }
            @if (!loadingMore && (totalItems+1 > ((1 + page)  * 24))) {
              <button
                htm-button
                (click)="loadMore()"
                type="button"
                data-test-id="related-study-programmes-load-more-button"
                >
                <span>{{ 'button.load_more' | translate }}</span>
                <span> ({{ (totalItems - ((1 + page) * 24)) }})</span>
              </button>
            }
          </div>
        }
      }



